module.exports = __webpack_public_path__ + "img/save_draft.9cd58631.png";